import { getGraphMarkets } from "./get-graph-markets";
import { getStaticMarkets } from "./get-static-markets";
import { getUserMarketAddresses } from "./get-user-market-addresses";
import { request } from "./request";

export const GraphClient = {
  getStaticMarkets,
  getGraphMarkets,
  getUserMarketAddresses,
  request,
};
